import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ResetState } from '@app/core/user/store/actions/user.actions';
import { IAppState } from '@app/store';
import { Store } from '@ngrx/store';
import { UserService } from '@app/core/user/services/user/user.service';
import { BREAKPOINTS } from '@app/store/reducers/device.reducer';

@Component({
  selector: 'vc-auth-modal',
  templateUrl: './auth-modal.component.html',
  styleUrls: ['./auth-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class AuthModalComponent implements OnInit {
  resetPassword: false;
  email: string;
  type: 'login' | 'register' | 'login-register' = 'login';
  popinForced: boolean;
  popover = false;

  constructor(
    private store: Store<IAppState>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService
  ) {
    if (this.data.type === 'register') {
      this.type = 'register';
    }

    this.popinForced = this.data.forced;
  }

  ngOnInit() {
    // this.store.dispatch(new ResetState());

    this.userService.getAuthDialogData().subscribe(
      res => {
        if (res) {
          this.email = res.credentials.email;

          if (res.authModalType === 'register') {
            this.type = 'register';
          }
        }
      },
      err => {}
    );

    if (window && window.innerWidth < BREAKPOINTS.medium) {
      this.type = window.innerWidth < BREAKPOINTS.medium ? 'login-register' : this.data.type;
    }
  }

  displayResetPassword(value) {
    this.resetPassword = value;
  }

  displayComponent(name: 'login' | 'register'): void {
    this.store.dispatch(new ResetState());
    this.type = name;
  }

  setCurrentEmail(value) {
    this.email = value;
  }

  togglePopover() {
    this.popover = !this.popover;
  }
}
